import z from "zod"

export const supportServicesSchema = z.object({
  wellbeing_staff: z.array(z.coerce.string<string>()),
  after_hours_contact: z.array(z.coerce.string<string>()),
})
